"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workspaceAdminAppRecommend = void 0;
exports.workspaceAdminAppRecommend = function (axios) {
    return {
        // 추천 앱 조회
        getWorkSpaceAdminAppsRecommend: function (request) {
            return axios.get('/apps/recommend', request);
        }
    };
};
